import {ThemingComponent} from './components/theming.component';
import {AdminThemingComponent} from './components/admin-theming.component';
import {AppearanceComponent} from './components/appearance.component';
import {CustomCssDialogComponent} from './components/custom-css-dialog.component';
import {SettingsThemeService} from './services/settings-theme.service';
import {UiSettingsService} from './services/ui-settings.service';
import {NAVIGATION} from './settings-theming.navigation';
import {routing} from './settings-theming.routing';
import {CommonModule} from '@angular/common';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {LayoutService} from '@ngmedax/layout';
import {ColorPickerModule} from 'ngx-color-picker';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from "@angular/forms";
import {CodemirrorModule} from '@ctrl/ngx-codemirror';
import {BrowserModule} from '@angular/platform-browser';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ColorPickerModule,
    NgbTooltipModule,
    NgbModule,
    BrowserModule,
    CodemirrorModule,
    routing,
  ],
  declarations: [
    ThemingComponent,
    AdminThemingComponent,
    AppearanceComponent,
    CustomCssDialogComponent
  ],
  exports: [],
  providers: [
    SettingsThemeService,
    UiSettingsService,
    {
      // applies the look of the instance (config defaults, cached and stored settings) before the first page
      provide: APP_INITIALIZER,
      useFactory: (uiSettings: UiSettingsService) => () => uiSettings.init(),
      deps: [UiSettingsService],
      multi: true
    }
  ]
})
export class SettingsThemingModule {
  constructor(private layoutService: LayoutService) {
    this.layoutService.addMenuEntry(NAVIGATION);
  }
}
